import { render, staticRenderFns } from "./UpsertAiPnConfiguration.vue?vue&type=template&id=18c2bb72&scoped=true&"
import script from "./UpsertAiPnConfiguration.vue?vue&type=script&lang=js&"
export * from "./UpsertAiPnConfiguration.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UpsertAiPnConfiguration.vue?vue&type=style&index=1&id=18c2bb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2bb72",
  null
  
)

export default component.exports